export default "__VITE_ASSET__BviiGZ5m__"